<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from '@/utils/ugm-swal';
import Multiselect from 'vue-multiselect';

export default {
    components: { Layout, PageHeader, Multiselect },
    data() {
        return {
            title: "Evaluaciones Coordinadores",
            items: [
                {
                text: "Usuarios",
                href: "/web/configuracion/usuarios"
                },
                {
                text: "Evaluaciones Coordinadores",
                active: true
                }
            ],
            usuarios:[],
            ordenCampo: 'promedio',
            ordenPromedio: 'desc',
            editing: false,
            dato:{
                id:'',
                coordinador:'',
                p1:'¿Prepara la actividad de manera anticipada y organizada?',
                r1:'',
                p2:'¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?',
                r2:'',
                p3:'¿Maneja el contenido de su presentación de manera correcta, identificando el interés del público por relato?',
                r3:'',
                p4:'¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?',
                r4:'',
            }
        };
    },
    computed: {
        usuariosOrdenados() {
            return [...this.usuarios].sort((a, b) => {
                let valA, valB;
                if (this.ordenCampo === 'promedio') {
                    valA = parseFloat(this.prom_general(a)) || 0;
                    valB = parseFloat(this.prom_general(b)) || 0;
                } else if (this.ordenCampo === 'nombre') {
                    valA = a.name.toLowerCase();
                    valB = b.name.toLowerCase();
                }
                if (valA < valB) return this.ordenPromedio === 'asc' ? -1 : 1;
                if (valA > valB) return this.ordenPromedio === 'asc' ? 1 : -1;
                return 0;
            });
        }
    },
    mounted() {
    },
    methods: {
        msg(tipo,titulo){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                //text: '',
                showConfirmButton: false,
                timer: 5000
            });
        },
        ver_mas(usuario){
            this.editing = false;
            usuario.boton = usuario.boton === 'Ver más' ? 'Ver menos' : 'Ver más';
        },
        showModal(us,ev){
            this.dato = {
                coordinador: us.name,
                id: ev.id,
                user_id: us.id,
                p1: ev.p1==null?this.dato.p1:ev.p1,
                r1: ev.r1,
                p2: ev.p2==null?this.dato.p2:ev.p2,
                r2: ev.r2,
                p3: ev.p3==null?this.dato.p3:ev.p3,
                r3: ev.r3,
                p4: ev.p4==null?this.dato.p4:ev.p4,
                r4: ev.r4
            };
            this.$refs['modal-evaluar'].show()
        },
        prom_general(item){
            let suma = 0;
            let total =0;
            item.evaluaciones.forEach(element => {
                if (element.prom!=null) {
                    suma = suma+ parseFloat(element.prom);
                    total = total +1;
                }
            });
            return total ? (suma / total).toFixed(2) : '0.00';
        },
        responder(){
            let formData = new FormData();
            formData.append('id', this.dato.id);
            formData.append('user_id', this.dato.user_id);
            formData.append('p1', this.dato.p1);
            formData.append('r1', this.dato.r1);
            formData.append('p2', this.dato.p2);
            formData.append('r2', this.dato.r2);
            formData.append('p3', this.dato.p3);
            formData.append('r3', this.dato.r3);
            formData.append('p4', this.dato.p4);
            formData.append('r4', this.dato.r4);
            axios.post('/api/guardar_evaluacion_coordinador',formData).then(res=>{
                if (res.data.estado) {
                    Swal.fire({
                        //position: "top-end",
                        icon: 'success',
                        title: 'Se ha guardado la evaluación',
                        //text: '',
                        showConfirmButton: false,
                        timer: 5000
                    });
                    this.resetDato();
                    this.cargarUsuarios();
                }
            });
        },
        resetDato() {
            this.dato = {
                id:'',
                coordinador:'',
                p1:'¿Prepara la actividad de manera anticipada y organizada?',
                r1:'',
                p2:'¿Su presentación personal es acorde con el estándar institucional y a la actividad realizada?',
                r2:'',
                p3:'¿Maneja el contenido de su presentación de manera correcta, identificando el interés del público por relato?',
                r3:'',
                p4:'¿Se desenvuelve en la actividad de manera empática con los alumnos, generando espacios de interacción y resolución de dudas?',
                r4:'',
            };
            this.$refs['modal-evaluar'].hide(); // <-- Cierra el modal
        },
        cargarUsuarios() {
            axios.get('/api/get_todas_evaluaciones_coordinadores').then(res => {
                if (this.user.rol=='SuperAdmin' || this.user.rol=='Admin' || this.user.rol=='Supervisor') {
                    this.usuarios = res.data.coordinadores.map(u => ({
                        ...u,
                        boton: 'Ver más'
                    }));
                }else if (this.user.rol=='Coordinador') {
                    this.usuarios = res.data.coordinadores.filter(us => us.id==this.user.id);
                }
                
            });
        },
        descargar(){
            // Mostrar indicador de carga
            Swal.fire({
                title: 'Generando archivo...',
                text: 'Por favor espere',
                allowOutsideClick: false,
                showConfirmButton: false,
                willOpen: () => {
                    Swal.showLoading();
                }
            });

            axios.get('/api/export_evaluaciones_coordinadores', { responseType: 'blob' }).then(res=>{
                Swal.close(); // Cerrar indicador de carga
                
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement('a');
                
                // Intentar obtener nombre desde header
                const disposition = res.headers['content-disposition'] || '';
                let fileName = 'evaluaciones_coordinadores_' + new Date().toISOString().slice(0,10) + '.xlsx';
                
                // Mejorar expresión regular para capturar el nombre del archivo
                const match = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
                if (match && match[1]) {
                    fileName = match[1].replace(/['"]/g, '');
                }
                
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                
                // Limpiar después de un breve delay para asegurar que la descarga inicie
                setTimeout(() => {
                    link.remove();
                    window.URL.revokeObjectURL(url);
                }, 100);
                
                this.msg('success', 'Archivo descargado correctamente');
            }).catch(err=>{
                Swal.close(); // Cerrar indicador en caso de error
                console.error('Error al descargar:', err);
                this.msg('error', 'No se pudo generar el archivo. Intente nuevamente.');
            })
        },
    },
    created(){
        this.cargarUsuarios();
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header py-3 d-flex align-items-center justify-content-between"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <div class="d-flex align-items-center">
                            <i class="bx bx-star font-size-24 text-white mr-2"></i>
                            <div>
                                <h5 class="text-white mb-0 font-weight-bold">Evaluaciones Coordinadores</h5>
                                <small class="text-white" style="opacity:.8;">Gestiona las evaluaciones de coordinadores</small>
                            </div>
                        </div>
                        <button v-if="user.rol === 'SuperAdmin' || user.rol === 'Admin' || user.cargo === 'Supervisor'"
                            class="btn-ugm-gold" @click="descargar">
                            <i class="bx bx-download mr-1"></i> Descargar Resumen
                        </button>
                    </div>
                    <div class="card-body p-0">
                        <div v-if="usuariosOrdenados.length === 0" class="text-center py-5">
                            <i class="bx bx-star font-size-48 d-block mb-2" style="color:#CB9700;"></i>
                            <p class="text-muted mb-0">No hay evaluaciones registradas</p>
                        </div>
                        <div v-else class="table-responsive">
                            <table class="table table-hover mb-0">
                                <thead style="background:#252C5F;color:#fff;">
                                    <tr>
                                        <th class="font-weight-normal py-2 pl-3" style="width:5%">#</th>
                                        <th class="font-weight-normal py-2" style="width:35%">
                                            Nombre
                                            <button class="btn-sort ml-1" @click="ordenCampo === 'nombre' ? (ordenPromedio = ordenPromedio === 'asc' ? 'desc' : 'asc') : (ordenCampo = 'nombre', ordenPromedio = 'asc')">
                                                <i :class="ordenCampo === 'nombre' ? (ordenPromedio === 'asc' ? 'bx bx-sort-up' : 'bx bx-sort-down') : 'bx bx-sort'"></i>
                                            </button>
                                        </th>
                                        <th class="font-weight-normal py-2" style="width:15%">RUT</th>
                                        <th class="font-weight-normal py-2" style="width:30%">
                                            Promedio General
                                            <button class="btn-sort ml-1" @click="ordenCampo === 'promedio' ? (ordenPromedio = ordenPromedio === 'asc' ? 'desc' : 'asc') : (ordenCampo = 'promedio', ordenPromedio = 'desc')">
                                                <i :class="ordenCampo === 'promedio' ? (ordenPromedio === 'asc' ? 'bx bx-sort-up' : 'bx bx-sort-down') : 'bx bx-sort'"></i>
                                            </button>
                                        </th>
                                        <th class="font-weight-normal py-2 text-center" style="width:15%">Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(usuario, index) in usuariosOrdenados">
                                        <tr :key="'u-'+usuario.id">
                                            <td class="pl-3">{{ index + 1 }}</td>
                                            <td class="font-weight-semibold">{{ usuario.name }}</td>
                                            <td class="text-muted">{{ usuario.rut }}</td>
                                            <td>
                                                <span v-for="i in 5" :key="i"
                                                    :class="prom_general(usuario) >= i ? 'bx bxs-star text-warning' : 'bx bxs-star text-muted'"
                                                    style="font-size:1rem;margin-right:2px;"></span>
                                                <span class="ml-2 font-weight-semibold" style="color:#252C5F;">{{ prom_general(usuario) }}</span>
                                            </td>
                                            <td class="text-center">
                                                <button class="btn-ugm-white" style="font-size:.8rem;padding:4px 10px;white-space:nowrap;"
                                                    v-b-toggle="'accordion-'+usuario.id" @click="ver_mas(usuario)">
                                                    <i :class="usuario.boton === 'Ver menos' ? 'bx bx-chevron-up' : 'bx bx-chevron-down'"></i>
                                                    {{ usuario.boton || 'Ver más' }}
                                                </button>
                                            </td>
                                        </tr>
                                        <tr :key="'collapse-'+usuario.id">
                                            <td colspan="5" class="p-0 border-0">
                                                <b-collapse :id="'accordion-'+usuario.id" accordion="my-accordion" role="tabpanel">
                                                    <div class="p-3" style="background:#f8f9fa;">
                                                        <div class="d-flex align-items-center mb-2">
                                                            <div style="width:4px;height:14px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                                            <span class="font-weight-bold" style="color:#252C5F;font-size:.85rem;">Evaluaciones por mes</span>
                                                        </div>
                                                        <div class="table-responsive">
                                                            <table class="table table-sm bg-white mb-0" style="border-radius:6px;overflow:hidden;">
                                                                <thead style="background:#61B7E4;color:#fff;">
                                                                    <tr>
                                                                        <th class="font-weight-normal py-1 pl-3" style="width:5%">Nº</th>
                                                                        <th class="font-weight-normal py-1">Mes / Año</th>
                                                                        <th class="font-weight-normal py-1">Promedio</th>
                                                                        <th class="font-weight-normal py-1 text-center">Acción</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(ev, index2) in usuario.evaluaciones" :key="index2">
                                                                        <td class="pl-3">{{ index2 + 1 }}</td>
                                                                        <td>{{ ev.mes_ano }}</td>
                                                                        <td>
                                                                            <span v-if="ev.prom !== null" class="font-weight-semibold" style="color:#252C5F;">{{ ev.prom }}</span>
                                                                            <span v-else class="text-muted" style="font-size:.8rem;">Sin evaluar</span>
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <button v-if="ev.r1 === null && (user.rol === 'SuperAdmin' || user.rol === 'Admin' || user.cargo === 'Supervisor')"
                                                                                class="btn-ugm-dark" style="font-size:.75rem;padding:3px 12px;"
                                                                                @click="showModal(usuario, ev)">
                                                                                <i class="bx bx-edit mr-1"></i> Contestar
                                                                            </button>
                                                                            <button v-else-if="ev.r1 !== null"
                                                                                class="btn-ugm-white" style="font-size:.75rem;padding:3px 12px;"
                                                                                @click="showModal(usuario, ev)">
                                                                                <i class="bx bx-show mr-1"></i> Ver resultados
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </b-collapse>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <b-modal ref="modal-evaluar" size="lg" :title="'Evaluar a ' + dato.coordinador" hide-footer @hidden="resetDato">
                        <div class="row" v-for="(pregunta, idx) in [
                            { label: dato.p1, model: 'r1', titulo: 'Preparación' },
                            { label: dato.p2, model: 'r2', titulo: 'Presentación Personal' },
                            { label: dato.p3, model: 'r3', titulo: 'Contenido' },
                            { label: dato.p4, model: 'r4', titulo: 'Habilidades' }
                        ]" :key="idx">
                            <div class="col-md-12 mb-3">
                                <div class="p-3" style="border:1px solid #dee2e6;border-radius:8px;">
                                    <div class="d-flex align-items-center mb-2">
                                        <div style="width:4px;height:14px;background:#CB9700;border-radius:2px;margin-right:8px;"></div>
                                        <span class="font-weight-semibold" style="color:#252C5F;">{{ pregunta.titulo }}</span>
                                    </div>
                                    <p class="text-muted mb-3" style="font-size:.85rem;">{{ pregunta.label }}</p>
                                    <div class="d-flex align-items-center flex-wrap">
                                        <span class="text-muted mr-3" style="font-size:.8rem;">En desacuerdo</span>
                                        <b-form-radio-group
                                            :id="'btn-radio-' + pregunta.model"
                                            v-model="dato[pregunta.model]"
                                            :name="'radio-' + pregunta.model"
                                            buttons
                                            button-variant="warning">
                                            <b-form-radio v-for="i in 5" :key="i" :value="String(i)">{{ i }}</b-form-radio>
                                        </b-form-radio-group>
                                        <span class="text-muted ml-3" style="font-size:.8rem;">Muy de acuerdo</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-right mt-2" v-if="user.rol === 'SuperAdmin' || user.rol === 'Admin' || user.cargo === 'Supervisor'">
                            <button class="btn-ugm-white mr-2" @click="resetDato">Cancelar</button>
                            <button class="btn-ugm-dark" @click="responder">
                                <i class="bx bx-save mr-1"></i> Guardar
                            </button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.btn-ugm-gold {
    background: #CB9700 !important;
    color: #fff !important;
    border: 1px solid #CB9700 !important;
    border-radius: 6px;
    padding: 6px 16px;
    font-size: .85rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-gold:hover { opacity: .88; }
.btn-ugm-dark {
    background: #252C5F !important;
    color: #fff !important;
    border: 1px solid #252C5F !important;
    border-radius: 6px;
    padding: 6px 16px;
    font-size: .85rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-dark:hover { opacity: .85; }
.btn-ugm-white {
    background: #fff !important;
    color: #252C5F !important;
    border: 1px solid #252C5F !important;
    border-radius: 6px;
    padding: 5px 10px;
    font-size: .8rem;
    cursor: pointer;
    transition: opacity .2s;
}
.btn-ugm-white:hover { opacity: .8; }
.btn-sort {
    background: transparent;
    border: none;
    color: #fff;
    padding: 0 2px;
    cursor: pointer;
    font-size: .9rem;
    vertical-align: middle;
}
.btn-sort:hover { opacity: .7; }
</style>